import React, { useState, useEffect } from "react";
import "./Consulting.css";
import consulting from "../../../Assets/img/consulting.png";
import HeaderConsulting from "../../Hoc/HeaderConsulting";
import Footer from "../../Hoc/Footer";
import axios from "axios";
import swal from "sweetalert";
import ReactGA from "react-ga4";

function FreeConsulting() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [age, setAge] = useState("");
  const [education, setEducation] = useState("");
  const [grade, setGrade] = useState("");
  const [language, setLanguage] = useState("");
  const [budget, setBudget] = useState("");
  const [user, setUser] = useState([]);

  useEffect(() => {
    getUser();
  }, []);

  const getUser = () => {
    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/get-user/${localStorage.getItem(
          "token"
        )}`
      )
      .then((response) => {
        setUser(response.data);
      })
      .catch((err) => console.log(err));
  };

  // چک کردن اینکه همه فیلدها پر شدن یا نه
  const isFormValid =
    name.trim() !== "" &&
    email.trim() !== "" &&
    phone.length === 11 &&
    age.trim() !== "" &&
    education !== "" &&
    grade !== "" &&
    language !== "" &&
    budget !== "" &&
    user?._id;

  const createConsulting = () => {
    if (!isFormValid) {
      swal({
        title: "!خطا",
        text: "!لطفا همه فیلدها را کامل کنید",
        icon: "error",
        button: "!باشه",
      });
      return;
    }

    const payload = {
      user_id: user._id,
      name,
      email,
      phone,
      age,
      education,
      grade,
      language,
      budget,
      type: "free",
    };

    axios
      .post(
        "https://arianaapp.arianaapply.com/api/V1/free-consultation",
        payload
      )
      .then((response) => {
        ReactGA.event({
          category: "submit",
          action: "Free Consulting",
          label: "Consultant",
        });
        swal({
          title: "!ثبت شد",
          text: "!فرم مشاوره شما با موفقیت ثبت شد",
          icon: "success",
          button: "!باشه",
        });
      })
      .catch((error) => {
        console.log(error);
        swal({
          title: "!ثبت نشد",
          text: error.response?.data?.message || "!فرم مشاوره ثبت نشد",
          icon: "error",
          button: "!باشه",
        });
      });
  };

  return (
    <div className="resume">
      <div className="resume-body">
        <HeaderConsulting />

        <div className="c-resume-body">
          <div className="resume-header">
            <div className="resume-header-text">درخواست مشاوره رایگان</div>
            <div className="resume-header-pic">
              <img src={consulting} alt="" />
            </div>
          </div>

          <div className="resume-inputs">
            <div className="free-cns-boxes">
              <span>نام و نام خانوادگی</span>
              <input
                className="consulting-style"
                type="text"
                placeholder="مهدی بهرامی"
                onChange={(e) => setName(e.target.value)}
                value={name}
              />
            </div>

            <div className="free-cns-boxes">
              <span>شماره تماس</span>
              <input
                className="consulting-style"
                type="number"
                placeholder="09xxxxxxxxx"
                onChange={(e) => setPhone(e.target.value)}
                value={phone}
              />
            </div>

            <div className="free-cns-boxes">
              <span>ایمیل</span>
              <input
                className="consulting-style"
                type="email"
                placeholder="Example@gmail.com"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
              />
            </div>

            <div className="free-cns-boxes">
              <span>سن</span>
              <input
                className="consulting-style"
                type="number"
                placeholder="22"
                onChange={(e) => setAge(e.target.value)}
                value={age}
              />
            </div>

            <div className="free-cns-boxes">
              <span>تحصیلات</span>
              <select
                className="consulting-style1"
                onChange={(e) => setEducation(e.target.value)}
                value={education}
              >
                <option value="">انتخاب تحصیلات...</option>
                <option value="دکتری">دکتری</option>
                <option value="فوق لیسانس">فوق لیسانس</option>
                <option value="لیسانس">لیسانس</option>
                <option value="فوق دیپلم">فوق دیپلم</option>
                <option value="دیپلم">دیپلم</option>
                <option value="زیر دیپلم">زیر دیپلم</option>
              </select>
            </div>

            <div className="free-cns-boxes">
              <span>مقطع مورد نظر</span>
              <select
                className="consulting-style1"
                onChange={(e) => setGrade(e.target.value)}
                value={grade}
              >
                <option value="">انتخاب مقطع...</option>
                <option value="کاردانی">کاردانی</option>
                <option value="کارشناسی">کارشناسی</option>
                <option value="کارشناسی ارشد">کارشناسی ارشد</option>
                <option value="دکتری">دکتری</option>
                <option value="پست داک">پست داک</option>
              </select>
            </div>

            <div className="free-cns-boxes">
              <span>مدرک زبان</span>
              <select
                className="consulting-style1"
                onChange={(e) => setLanguage(e.target.value)}
                value={language}
              >
                <option value="">انتخاب مدرک زبان...</option>
                <option value="بدون مدرک">بدون مدرک</option>
                <option value="دارای مدرک آیلتس/تافل">
                  دارای مدرک آیلتس/تافل
                </option>
              </select>
            </div>

            <div className="free-cns-boxes">
              <span>بودجه</span>
              <select
                className="consulting-style1"
                onChange={(e) => setBudget(e.target.value)}
                value={budget}
              >
                <option value="">انتخاب بودجه...</option>
                <option value="100 میلیون تومان">100 میلیون تومان</option>
                <option value="بین 100 تا 400 میلیون تومان">
                  بین 100 تا 400 میلیون تومان
                </option>
                <option value="بین 400 تا 1 میلیارد تومان">
                  بین 400 تا 1 میلیارد تومان
                </option>
                <option value="بیشتر از 1 میلیارد تومان">
                  بیشتر از 1 میلیارد تومان
                </option>
              </select>
            </div>
          </div>

          <div className="consulting-btn">
            <button
              className="create-consulting-btn"
              onClick={createConsulting}
              disabled={!isFormValid}
              style={{
                backgroundColor: isFormValid ? "#28a745" : "#aaa",
                cursor: isFormValid ? "pointer" : "not-allowed",
                opacity: isFormValid ? 1 : 0.7,
                transition: "all 0.3s ease",
              }}
            >
              ثبت
            </button>
          </div>
        </div>

        <Footer active="cons" />
      </div>
    </div>
  );
}

export default FreeConsulting;